import { PencilSimple, NotePencil, Envelope } from "phosphor-react";
import { type TableMenuItem } from "../ReusableComponents/Table/TableMenu";
import { type DriverDeclaration } from "../../models/api/admin/eDeclarations";
import { DeclarationStatus } from "../../models/shared/statuses";
import { DeclarationType } from "../../models/app/eDeclarations";
import { isUkLicence } from "../../constants/countries";

export const driverDeclarationsMenuItems = (
    data: DriverDeclaration,
    editDriverClickHandler: (driverId?: string) => void,
    declarationRequestAction: (driverId: string) => void,
    switchDeclarationTypeAction: (
        driverId: string,
        declarationType: DeclarationType
    ) => void,
    isLoading?: boolean
): TableMenuItem[] => {
    const declarationId = data.inFlightDeclarationId ?? data.declarationId;
    const driverId = data.driverId;
    const activeDeclarationType =
        data.inFlightDeclarationType ?? data.declarationType;
    const canSwitchDeclarationType =
        data.declarationStatus === DeclarationStatus.Requested ||
        data.declarationStatus === DeclarationStatus.None ||
        !!data.inFlightDeclarationId;

    const editDriverOption: TableMenuItem = {
        key: "editDriver",
        onClick: () => editDriverClickHandler(driverId),
        icon: <PencilSimple size={20} weight="fill" />,
        text: `Edit Driver`,
    };

    const sendEDecEmailOption: TableMenuItem = {
        key: "sendEdecRequest",
        onClick: () => declarationRequestAction(declarationId),
        icon: <Envelope size={20} weight="fill" />,
        text: `Send E-Declaration email`,
    };

    const sendPaperDecEmailOption: TableMenuItem = {
        key: "sendEdecRequest",
        onClick: () => declarationRequestAction(declarationId),
        icon: <Envelope size={20} weight="fill" />,
        text: `Send Paper Declaration email`,
    };

    const switchToPaperOption: TableMenuItem = {
        key: "switchToPaper",
        onClick: () =>
            switchDeclarationTypeAction(
                declarationId,
                DeclarationType.PaperDeclaration
            ),
        icon: <NotePencil size={20} weight="fill" />,
        text: `Switch to Paper Declaration`,
        isLoading,
    };

    const switchToEDecOption: TableMenuItem = {
        key: "switchToEDec",
        onClick: () =>
            switchDeclarationTypeAction(
                declarationId,
                DeclarationType.EDeclaration
            ),
        icon: <NotePencil size={20} weight="fill" />,
        text: `Switch to E-Declaration`,
        isLoading,
    };

    const sendEmail =
        activeDeclarationType === DeclarationType.EDeclaration
            ? sendEDecEmailOption
            : sendPaperDecEmailOption;
    const switchDeclarationType =
        activeDeclarationType === DeclarationType.EDeclaration
            ? switchToPaperOption
            : switchToEDecOption;

    if (!canSwitchDeclarationType) {
        return [editDriverOption, sendEmail];
    }

    if (activeDeclarationType === DeclarationType.EDeclaration) {
        return [editDriverOption, sendEmail, switchDeclarationType];
    }

    // paper declarations can only switch to e-declaration for UK licences
    if (isUkLicence(data.licenceOrigin)) {
        return [editDriverOption, sendEmail, switchDeclarationType];
    }

    return [editDriverOption, sendEmail];
};
